<home-wrapper [homeTab]="'BUDGET'" [viewMode]="'table'">
  <loader-pane-fragment [trace]="traceNames.viewHomeBudget"></loader-pane-fragment>
  <account-menu [isBudget]="true" (openAccount)="openAccount($event)">
    <div class="wrap">
      <joi-nav-wrapper
        [menuItems]="menuItems"
        [menuMap]="menuMap"
        [selectedId]="subPage" 
        (selectItem)="changeSubpage($event)"
      ></joi-nav-wrapper>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </account-menu>



</home-wrapper>